export const ROOT_LOG_NAME = 'rosi-ui';

export interface PinoLogObject {
  time: number;
  level: number;
  logName: string;
  msg: string;
  [key: string]: unknown;
}

export interface LogObject {
  ts: string;
  level: string;
  logName: string;
  msg: string;
  args?: object;
}
